import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { DlqFooter } from "./DlqNode";

function QueueNode({ data, selected }) {
  const {
    stageKey,
    shortName,
    sent,
    deleted,
    colors,
    hasLambdaFeed,
    hasDlq,
    dlqVisible,
    dlqColors,
  } = data;
  const isStart = stageKey === "A";
  const isTerminal = ["F", "G", "H"].includes(stageKey);

  return (
    <div className={`w-[170px] ${selected ? "ring-2 ring-ktx-purple ring-offset-2 rounded-lg" : ""}`}>
      <div
        className={`relative border-2 min-w-[170px] w-[170px] box-border shadow-md transition-colors duration-150 cursor-pointer ${
          hasDlq ? "rounded-t-lg rounded-b-none border-b-0" : "rounded-lg"
        }`}
        style={{
          backgroundColor: colors.bg,
          borderColor: colors.border,
          color: colors.text,
          borderLeftWidth: 4,
          borderLeftColor: "#f59e0b",
        }}
      >
        {hasLambdaFeed && (
          <Handle
            type="target"
            position={Position.Left}
            id="from-lambda"
            style={{ top: "70%" }}
            className="!w-2 !h-2 !bg-gray-400"
          />
        )}
        {!isStart && (
          <Handle
            type="target"
            position={Position.Left}
            id="pipeline-in"
            className="!w-2 !h-2 !bg-gray-400"
          />
        )}
        <div className="px-3 py-1.5">
          <div className="flex items-start justify-between gap-2">
            <div className="font-semibold text-sm leading-tight">{shortName}</div>
            <span className="shrink-0 text-[9px] font-bold uppercase tracking-wider opacity-60 mt-0.5">
              SQS
            </span>
          </div>
          <div className="mt-1 space-y-0.5 text-xs font-medium">
            <div className="flex justify-between gap-4">
              <span className="opacity-80">Sent</span>
              <span>{sent}</span>
            </div>
            <div className="flex justify-between gap-4">
              <span className="opacity-80">Deleted</span>
              <span>{deleted}</span>
            </div>
          </div>
        </div>
        {!isTerminal && (
          <Handle
            type="source"
            position={Position.Right}
            id="pipeline-out"
            className="!w-2 !h-2 !bg-gray-400"
          />
        )}
      </div>
      {hasDlq && (
        <DlqFooter visible={dlqVisible} colors={dlqColors} selected={false} />
      )}
    </div>
  );
}

export default memo(QueueNode);
